module.exports = __webpack_public_path__ + "img/设备设施.0b7aa13e.svg";